import { ThemeProvider } from '@material-ui/core/styles';
import { theme } from '@nordkap/nordkap-ui';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import Admin from './containers/admin/index';
import FileGeneration from './containers/file-generation/index';
import Layout from './containers/layout/index';
import Loader from './containers/loader/index';
import NotFound from './containers/not-found/index';
import Position from './containers/position/index';

/* eslint no-underscore-dangle: ["error", { "allow": ["__RUNTIME_CONFIG__"] }] */
function App() {
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider maxSnack={3} hideIconVariant>
        <Layout>
          <Loader />
          <Router>
            <Switch>
              <Route
                path={`${window.__RUNTIME_CONFIG__.PUBLIC_URL}/editposition/:positionType/:positionId`}
              >
                <Position />
              </Route>
              <Route path={`${window.__RUNTIME_CONFIG__.PUBLIC_URL}/admin`}>
                <Admin />
              </Route>
              <Route path={window.__RUNTIME_CONFIG__.PUBLIC_URL}>
                <FileGeneration />
              </Route>
              <Route path="*">
                <NotFound />
              </Route>
            </Switch>
          </Router>
        </Layout>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
